// Import MDX content - only import published posts in production
// Draft posts should be commented out or removed from imports when building for prod

import HelloWorld from './hello-world.mdx';
import Article1 from './from-idea-to-shipping-building-full-stack-product-management-app-with-cursor.mdx';
import Article2 from './design-stack-2025.mdx';
import Article3 from './designer-in-the-ai-era.mdx';
import Article4 from './lessons-from-building-vertical-saas.mdx';
import Article5 from './formly-case-study.mdx';
import Article6 from './abax-case-study.mdx';
import Article7 from './booksy-case-study.mdx';
import Article8 from './building-developer-friendly-design-system.mdx';
// DRAFT imports - comment these out before production build to exclude from bundle
// import HelloWorldContent from './hello-world.mdx';

// Post metadata + MDX component
// Set published: false to hide in production (but still visible in dev)
// IMPORTANT: For true security, also comment out the import above for draft posts

const allPosts = [
  {
    slug: 'from-idea-to-shipping-building-full-stack-product-management-app-with-cursor',
    cover: '/case-studies/covers/Signals-cover.png',
    title:
      'From Idea to Shipping: Building a Full-Stack Product Management App with Cursor',
    date: '2025-07-15',
    excerpt:
      'Learn more about how I built a full-stack product management app with Cursor.',
    type: 'post',
    Content: Article1,
    published: true
  },
  {
    slug: 'design-stack-2025',
    title: 'Design stack 2025',
    date: '2025-11-10',
    excerpt: 'My design stack for 2025.',
    type: 'post',
    Content: Article2,
    published: true
  },
  {
    slug: 'designer-in-the-ai-era',
    title: 'Designer in the AI Era — What-If Scenarios',
    date: '2025-12-5',
    excerpt:
      'Two plausible futures of AI-driven product development and what they mean for designers, developers, and product teams.',
    type: 'post',
    Content: Article3,
    published: true
  },
  {
    slug: 'formly-case-study',
    title:
      'Digitising interior design workflows for studios and homeowners at Formly',
    date: '2025-03-02',
    cover: '/case-studies/covers/Formly-cover.png',
    excerpt: 'Stay tuned for more content!',
    type: 'case-study',
    Content: Article5,
    published: true
  },
  {
    slug: 'lessons-from-building-vertical-saas',
    title: 'Lessons from building vertical SaaS',
    date: '2025-05-07',
    excerpt: 'Stay tuned for more content!',
    type: 'post',
    Content: Article4,
    published: true
  },
  {
    slug: 'abax-case-study',
    title: 'Full-Stack Product Design for a Telematics Company',
    date: '2025-05-07',
    excerpt: 'Stay tuned for more content!',
    cover: '/case-studies/covers/Abax-cover.png',
    type: 'case-study',
    Content: Article6,
    published: true
  },
  {
    slug: 'hello-world',
    title: 'Hello World',
    date: '2025-08-15',
    excerpt: 'Stay tuned for more content!',
    type: 'post',
    Content: HelloWorld,
    published: false
  },
  {
    slug: 'booksy-case-study',
    title: 'Designing Effective AI-Assisted Onboarding for B2C at Booksy',
    cover: '/case-studies/covers/Booksy-cover.png',
    date: '2025-08-15',
    excerpt: 'Stay tuned for more content!',
    type: 'case-study',
    Content: Article7,
    published: true
  },
  {
    slug: 'building-developer-friendly-design-system',
    title: 'Building a Developer-Friendly Design System',
    cover: '/case-studies/covers/ZyteDS-getting-started.png',
    date: '2026-10-15',
    excerpt:
      'A developer-friendly, agentic-ready design system that also helps marketing ship static pages faster, without a CMS.',
    type: 'post',
    Content: Article8,
    published: true
  }
];

// Filter posts based on environment
// In production: only published posts
// In development: all posts (so you can preview drafts)
const isProduction = process.env.NODE_ENV === 'production';

const posts = allPosts.filter((post) => {
  if (isProduction) {
    return post.published === true && post.Content !== null;
  }
  // In dev, show all posts that have content
  return post.Content !== null;
});

export const getPostBySlug = (slug) => {
  return posts.find((post) => post.slug === slug);
};

export const getAllPosts = () => {
  return [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const getPostsByType = (type) => {
  return [...posts]
    .filter((post) => post.type === type)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};

export default posts;
